import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ItemService as ItemService, Item } from '../../invoice-created';
import * as Moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseWrapper } from '../../../shared/model/response-wrapper.model';
import { CONFIG } from '../../../shared/constants/config.constants';
import * as _ from 'lodash';
import { SystemSetting } from '../../system-setting';
import { SystemSettingStorageService } from '../../../shared/model/system-setting-storage.service';
import { FormatNumberInputProvider } from '../../../shared/components/format-number-input/format-number-input.component';
import { Item as ItemInfo } from './../Announcement.model';

import { LocalStorageService } from 'ng2-webstorage';
import { Announcementmodel } from '../Announcement.model';
import { DatePipe } from '@angular/common';
import { Announcementservice } from '../Announcement.service';
import {PopupService} from '../../../shared/services/popup/popup.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'announcement-preview',
	templateUrl: './Announcement-preview.component.html',
	styleUrls: ['./Announcement-preview.component.css']
})
export class AnnouncementpreviewComponent implements OnInit {

	routeData: any;
	items: Item[];
	invoiceSymbols: any;
	invoiceTemplates: any;
	searchParams: any = {
		invoiceStatus: null,
		code: null,
		symbol: null,
		invoiceSampleId: null,
		invoiceNo: null,
		dateTo: null
	};
	Sum: number = 0;
	systemSetting = new SystemSetting();
	info: ItemInfo;
	announcementmd: Announcementmodel;
	FlagUpdate = EnumUpdate.KHOITAO;
	userSID = 0;
	announcementDate: any;
	FlagUpdate_TEXT = "";
	FlagannouncementType = EnumType.KHOITAO;
	Actiontype = EnumActionType.ADDNEW;
	invoiceTemplateId: number;
	haveSymbol: any;
	public data: any;
	companyId: number;
	strAnnouncementDate: string;
	titlePage: string = "";
	currencyCode:string

	constructor(
		private itemService: ItemService,
		private systemSettingStorageService: SystemSettingStorageService,
		private formatNumberInputProvider: FormatNumberInputProvider,
		private annouService: Announcementservice,
		private localStorageService: LocalStorageService,
		public datepipe: DatePipe,
		private router: Router,
		public activeModal: NgbActiveModal,
	) {
		this.announcementmd = new Announcementmodel();
		this.LoadDateDefault();
	}

	LoadDateDefault() {
		var date = new Date(Date.now());
		this.announcementDate = {
			year: date.getFullYear(),
			month: date.getMonth() + 1,
			day: date.getDate()
		}
	}

	ngOnInit() {
		this.FlagUpdate = EnumUpdate.KHOITAO;
		let announcementId = +this.data.id;
		let verificationCode = +this.data.verificationCode;		
		let type = +this.data.type;
		this.invoiceTemplateId = null;
		this.LoadType();
		this.info = new ItemInfo();
		setTimeout(function () {
			if (announcementId) {
				this.LoadAnnouncementInfo(announcementId, type, verificationCode);
			} 
		}.bind(this));
	}

	loadSetting() {
		if (this.announcementmd && this.announcementmd.SystemSetting) {
			this.systemSetting = this.announcementmd.SystemSetting;
		}
	}

	digitInfo(input: number): string {
		return this.formatNumberInputProvider.digitInfo(input);
	}

	formatSearchParams(searchParams) {
		const formatedSearchParams = JSON.parse(JSON.stringify(searchParams));
		if (formatedSearchParams.dateFrom) {
			formatedSearchParams.dateFrom.month--;
			formatedSearchParams.dateFrom = Moment(formatedSearchParams.dateFrom).format(CONFIG.serverDateFormat);

			formatedSearchParams.dateTo = formatedSearchParams.dateFrom;
		}
		return formatedSearchParams;
	};

	loadListInvoiceTemplates() {
		this.annouService.getTemplates(this.companyId).subscribe(
			(res: ResponseWrapper) => this.onSuccessInvoiceTemplates(res.json)
		);
	}

	private onSuccessInvoiceTemplates(invoiceTemplates) {
		this.invoiceTemplates = _.sortBy(invoiceTemplates, [function (o) { return o.code; }]);
		
		if(this.searchParams.code == undefined){
			this.searchParams.code = this.invoiceTemplates[0].id;
		}
	}

	LoadAnnouncementInfo(announcementId: number, type: number, verificationCode: string) {
		if (announcementId != null) {			
			this.annouService.LoadList(announcementId, type, verificationCode).subscribe((x) => {
				this.companyId = x.CompanyId;
				this.FlagannouncementType = +type;
				this.FlagUpdate = EnumUpdate.KHOITAO;
				this.changetextupdate();
				this.announcementmd = x;
				this.loadSetting();
				this.GetValueUpdate();
				this.LoadConfig();
				this.loadListInvoiceTemplates();
				if(this.Actiontype == 1) {
					this.titlePage = 'announcement.substituteinvoice';
				} else if (this.Actiontype == 2) {
					this.titlePage = 'announcement.adjustmentinvoice';
				} else {
					this.titlePage = 'announcement.cancelinvoice';
				}
			});
		}
	}

	GetValueUpdate() {
		var date = new Date(this.announcementmd.InvoiceDate);
		this.searchParams.dateFrom = {
			year: date.getFullYear(),
			month: date.getMonth() + 1,
			day: date.getDate()
		}
		date = new Date(this.announcementmd.AnnouncementDate);
		this.announcementDate = {
			year: date.getFullYear(),
			month: date.getMonth() + 1,
			day: date.getDate()
		}
		let month = date.getMonth() + 1;
		this.strAnnouncementDate = date.getFullYear().toString() + '/' + month.toString() + '/' + date.getDate().toString();
		this.searchParams.invoiceNo = this.announcementmd.InvoiceNo;
		this.searchParams.code = this.announcementmd.RegisterTemplateId;
		this.searchParams.symbol = this.announcementmd.Symbol;
		this.Sum = this.announcementmd.TotalAmount;
		debugger
		this.currencyCode=  this.announcementmd.CurrencyCode;
		
	}

	LoadConfig() {
		this.annouService.find(this.companyId).subscribe((item) => {
			if (item.signatures && item.signatures.length > 0) {
				this.info.signatures = item.signatures[item.signatures.length - 1].serialNumber;
			}
			else {
				this.info.signatures = "";
			}
			debugger;
			this.info.id = item.id;
			this.info.companyName = item.parentName;
			this.info.delegate = item.parentDelegate;
			this.info.address = item.parentAddress;
			this.info.tel = item.parentTel;
			this.info.parentPosition = item.parentPosition;
			this.info.tax = item.tax;
			this.info.name = item.name;
			this.info.personContact = item.personContact;
			this.info.fax = item.fax;
			this.info.email = item.email;
			this.info.manager = item.manager;
		});
	}
	
	LoadType() {
		let type: number;
		type = +this.data.type;
		switch (type) {
			case EnumActionType.ADJUSTMENT: {
				this.Actiontype = EnumActionType.ADJUSTMENT;
				break;
			}
			case EnumActionType.DUYET: {
				this.Actiontype = EnumActionType.DUYET;
				break;
			}
			case EnumActionType.CANCEL: {
				this.Actiontype = EnumActionType.CANCEL;
				break;
			}
			case EnumActionType.SUBSTITUTE: {
				this.Actiontype = EnumActionType.SUBSTITUTE;
				break;
			}
			case EnumActionType.UPADTE: {
				this.Actiontype = EnumActionType.UPADTE;
				break;
			}
			case EnumActionType.ADDNEW: {
				this.Actiontype = EnumActionType.ADDNEW;
				break;
			}
		}
		this.announcementmd.ActionType = this.Actiontype;
		if (this.announcementmd.AnnouncementStatus === undefined) {
			this.announcementmd.AnnouncementStatus = EnumUpdate.TAOMOI;
		}
		this.changetextupdate();
	}

	changetextupdate() {
		switch (this.Actiontype) {
			case EnumActionType.ADJUSTMENT:
					this.FlagUpdate_TEXT = 'ĐIỀU CHỈNH HÓA ĐƠN';
				break;
			case EnumActionType.CANCEL:
					this.FlagUpdate_TEXT = 'Hủy hóa đơn';
				break;
			case EnumActionType.SUBSTITUTE:
					this.FlagUpdate_TEXT = 'Thay thế hóa đơn';
				break;
		}
	}
    checkCurrency(currency :string){
		if(currency && currency.toLocaleUpperCase()=="VND"){
			return true;
		}
		return false
	}
	SaveAction() {
	}

	clear() {
		this.activeModal.dismiss('cancel');
	}
}

@Component({
    selector: 'jhi-Preview-Announcement-popup',
    template: ''
})
export class ItemPreviewAnnouncementPopupComponent implements OnInit, OnDestroy {
    routeSub: any;
    itemDetails: any;
	
    constructor(
		private route: ActivatedRoute,
        private itemPopupService: PopupService,
	)
	{}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
			this.itemPopupService.openComponent(AnnouncementpreviewComponent as Component, {
				id: params['id'],
				type: params['type'],
				verificationCode: params['verificationCode'],
			});
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}

export enum EnumUpdate {
	KHOITAO = -1,
	TAOMOI = 1,
	DUYET = 3,
	DAHOANTAT = 99,
	UPDATE = 5
}

export enum EnumType {
	KHOITAO = - 1,
	DIEUCHINH = 0,
	THAYTHE = 1,
	HUY
}

export enum EnumActionType {
	ADJUSTMENT = 1,// DIEUCHINH,
	SUBSTITUTE = 2, //THAYTHE,
	CANCEL = 3,//HUY,
	ADDNEW = 4,
	DUYET,
	UPADTE
}
